<template>
  <div  v-if="pagearea.length > 0">
    <van-list
      v-model="areaLoading"
      :finished="areaFinished"
      @load="getData"
      :immediate-check="false"
      :offset="20"
    >
      <div class="area" v-for="(item, index) in pagearea" :key="index">
        <img @click="goImgCategory(item.area_nbr)" v-if="index <= areaIndex" class="areaTopImg"   :src="item.image_path" alt="">
        <div class="tabbox" v-if="item.areaList &&item.areaList.length > 0">
          <div class="tabboxm" v-for="(commodity,cIndex) in item.areaList" :key="cIndex" @click="golistdetail(commodity.nbr, commodity.rule_type)">
            <div class="tabboxmt">
              <img class="img" v-lazy="commodity.commodity_logo + `${imgCrop}resize,w_500`" alt="">
              <div :class="commodity.quantity==='0'?'noNum':'noNum hide'">
                <img v-lazy="require('../../assets/images/noNum.png')" alt="">
              </div>
              <img class="sales" v-if="commodity.start_state==0" src="../../assets/images/beSale.png" alt="">
            </div>
            <div class="border"></div>
            <div class="tanboxmm1 sigle-twoh">
              {{commodity.commodity_name}}
            </div>
            <div>
              <div class="commoditySummary sigle-h"  :style="commodity.commodity_summary?{background:'#FFF0B0'}:null">{{commodity.commodity_summary}}</div>
            </div>
            <div>
              <div v-if="commodity.is_sales_show=='1'" class="commoditySummarySales sigle-h" style="background:#EEF7FF">已抢{{commodity.show_sales_num}}件</div>
              <div v-else class="commoditySummarySales sigle-h"> </div>
            </div>
            <div class="tanboxmb">
              <span class="bold" v-if="commodity.rule_type=='2'"><i>￥</i>{{roleNewText=='sell'&&commodity.show_price?commodity.show_price:commodity[`min_${roleNewText}_price`]}}<span v-if="Math.round((commodity[`min_sell_price`] - commodity[`min_${roleNewText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((commodity[`min_sell_price`] - commodity[`min_${roleNewText.toLowerCase()}_price`])*100)/100}}--></span>
              </span>
              <span class="bold" v-else><i>￥</i>{{roleText=='sell'&&commodity.show_price?commodity.show_price:commodity[`min_${roleText}_price`]}}<span v-if="Math.round((commodity[`min_sell_price`] - commodity[`min_${roleText.toLowerCase()}_price`])*100)/100!=0"><!--/<i>赚</i>￥{{Math.round((commodity[`min_sell_price`] - commodity[`min_${roleText.toLowerCase()}_price`])*100)/100}}--></span>
              </span>
            </div>
            <div class="couponbox">
              <span class="tanboxmbspan">￥{{commodity.old_price}}</span>
              <div :class="commodity.is_use_coupon=='0'?'coupon1 hide':'coupon1'">可用券</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  props: {
    pagearea: {
      type: Array,
    },
    roleText: {
      type: String,
      default: "sell"
    },
    roleNewText: {
      type: String,
      default: "sell"
    },
    isLogin:{
      type: Number,
    },
    changeArea:{
      type:Function,
    }
  },
  data() {
    return {
      areaLoading:false,
      areaFinished:false,
      areaIndex:0,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    goImgCategory(nbr){
      this.$router.push({ path: "/explosive", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
    },
    golistdetail(nbr, rule_type) {
      if(rule_type=='2'){
        this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }else{
        this.$router.push({ path: "/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }
    },
    getData(num) {
      this.areaLoading = true
      if(num==0) this.areaIndex = 0
      //热门专区
      this.$commonPost({
        jydm: "flow_70013",
        flow_70013: {
          area_nbr: this.pagearea[this.areaIndex].area_nbr,
          page_index: (this.pagearea[this.areaIndex].pageIndex||0) * (this.pagearea[this.areaIndex].show_num||10),
          num_per_page: this.pagearea[this.areaIndex].show_num||10,
          type: "-1"
        }
      })
        .then(response => {
          let arr = [];
          if (response.commodity) {
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          this.pagearea[this.areaIndex].areaList = (this.pagearea[this.areaIndex].areaList||[]).concat(arr);
          this.pagearea[this.areaIndex].pageIndex = (this.pagearea[this.areaIndex].pageIndex||0) + 1
          if(arr.length < (this.pagearea[this.areaIndex].show_num||10)){
            this.areaIndex += 1;
          }
          if(this.areaIndex >= this.pagearea.length){
             this.areaFinished = true
          }else{
             this.areaFinished = false
          }
          this.areaLoading = false
        })
        .catch(err => {
          this.areaLoading = false
          if(this.areaIndex < this.pagearea.length){
             this.areaIndex += 1;
          }else{
            this.areaFinished = true
          }
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
  },
  created() {},
  mounted() {
    this.getData();
  }
};
</script>

<style scoped lang='stylus'></style>
<style scoped lang='less'>
.area{
  width:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  .areaTopImg{
   width:7.02rem;
   height: 2.4rem;
   border-radius:.16rem;
   margin: .24rem auto 0;
   object-fit: cover;
 }
 
.tabbox {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.sigle-twoh {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.tabboxm {
  margin-top: 0.24rem;
  width: 3.42rem;
  height: 6.2rem;
  background: #fff;
  border-radius: 0.16rem;
  overflow: hidden;
  border: 1px solid #dddddd;
  position: relative;
}
.border {
  width: 3.26rem;
  height: 1px;
  background:#ddd;
  margin: 0 auto;
}
.tabboxm:nth-of-type(2n) {
  margin-left: 0.18rem;
}

.tabboxm:nth-of-type(2n - 1) {
  margin-left: 0.24rem;
}
.tabboxmt {
  position: relative;
}
.tabboxm .noNum {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  background: rgba(51, 51, 51, 0.3);
  width: 100%;
  height: 3.43rem;
}
.tabboxm .noNum img {
  width: 3rem;
  height: 2.3rem;
}
.tabboxmt .img {
  width: 3.42rem;
  height: 3.43rem;
  object-fit: cover;
}
.tabboxmt .sales {
  width: 1.16rem;
  height: 0.3rem;
  position: absolute;
  bottom: -0.15rem;
  left: 0.1rem;
  z-index: 9;
}

.tanboxmm1 {
  width: 3.22rem;
  line-height: 0.32rem;
  height: 0.62rem;
  margin: 0 0.1rem;
  font-size: 0.24rem;
  margin-top: 0.22rem;
  color: #333333;
}

.tanboxmm2 {
  line-height: 0.32rem;
  margin: 0 0.24rem;
  margin-top: 0.15rem;
  font-size: 0.22rem;
  color: #999;
}

.tanboxmb {
  margin-top: 0.2rem;
  line-height: 0.33rem;
  overflow: hidden;
}

.tanboxmb span:nth-of-type(1) {
  color: #333;
  font-size: 0.3rem;
  margin-left: 0.08rem;
  font-weight: bold;
}
.tanboxmb span:nth-of-type(1) i:nth-of-type(1){
  font-size: 0.24rem;
  color: #333333;
}
.tanboxmb span:nth-of-type(1) span:nth-of-type(1) {
  font-size: 0.24rem;
  color: #E52B25;
  margin-left:0.04rem;
  font-weight: bold;
}
.tanboxmb span:nth-of-type(1) span:nth-of-type(1) i:nth-of-type(1){
  font-size: 0.24rem;
  color: #E52B25;
  margin-left:0.04rem;
}
.tanboxmbspan{
  font-size: 0.24rem;
  text-decoration: line-through;
  color: #666;
  margin-left: 0.08rem;
}

.tanboxmb span i {
  font-size: 0.2rem;
}
.couponbox{
  margin-top: 0.08rem;
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.coupon1 {
  width:0.9rem;
  height:0.31rem;
  color: #f53547;
  font-size: 0.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background:url(../../assets/images/FFF1F2.png) no-repeat;
  background-size:0.9rem 0.3rem;
  position: absolute;
  right: 0;
  bottom: 0.14rem;
}
.coupon {
  background: #fff1f2;
  color: #f53547;
  font-size: 0.18rem;
  padding: 0.02rem 0.07rem;
  border-radius: 0.04rem;
  position: relative;
  top: -0.04rem;
}
.coupon.style1 {
  border-radius: 0.04rem;
  font-size: 0.18rem;
  position: static;
  display: inline-block;
  padding: 0.06rem 0.13rem;
}

.hide {
  display: none !important;
}
.nomore {
  text-align: center;
  color: #999999;
  line-height: 30px;
  margin-top: 0.1rem;
}
}
.commoditySummary{
  font-size: .2rem;
  color: #FF3500;
  margin-top: 0.1rem;
  font-weight: 500;
  padding: 0.04rem 0.1rem;
  border-radius: 0.04rem;
  display: inline-block;
  height: .26rem;
  max-width: 2.7rem;
  line-height: 1.5;
  margin-left: .1rem;
} 
.commoditySummarySales{
  font-size: .2rem;
  color: #0074FF;
  margin-top: 0.1rem;
  font-weight: 500;
  padding: 0.04rem 0.1rem;
  border-radius: 0.04rem;
  display: inline-block;
  height: .26rem;
  max-width: 2.7rem;
  line-height: 1.5;
  margin-left: .1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/index/hotArea.vue